import React  from 'react';

class CloudModule extends React.Component {
	constructor() {
		super();
		this.state = {
			cloudModule: null,
			surfaceHeight: 500,
			height: 250
		};
		this.closeCard = this.closeCard.bind(this);
		this.createCloud = this.createCloud.bind(this);
		this.clearCloud = this.clearCloud.bind(this);
	}
    componentWillUnmount() {
        this.clearCloud();
    }
	closeCard() {
		this.clearCloud();
		this.props.setCloudModuleOpen();
	}
	surfaceHeightChange(e) {
		this.setState({surfaceHeight: e.target.valueAsNumber});
	}
	heightChange(e) {
		this.setState({height: e.target.valueAsNumber});
	}
	createCloud() {
		const {cloudModule, surfaceHeight, height} = this.state;
		var _cloudModule = null;
		if (window.main !== null) {
			if (cloudModule === null) {
				_cloudModule = window.main.OView.getModule("cloud");
				this.setState({cloudModule: _cloudModule});
			} else {
				_cloudModule = cloudModule;
			}
			window.main.OView.inputSurfacePolygon({
				onCompleted: function (res) {
					if (res.success) {
						_cloudModule.addCloudEntity({
							geo: res.geo,
							surfaceHeight: parseFloat(surfaceHeight),
							height: parseFloat(height)
						});
					}
				}
			});
		}
	}
	clearCloud () {
		const {cloudModule} = this.state;
		if (cloudModule !== null) {
			cloudModule.removeAllCloudEntity();
		}
	}
	render() {
		const isOpen = this.props.isOpen;
		const cardStyle = {
			zIndex: "100",
			transform: isOpen ? 'translate3d(0, 0, 0)' : 'translate3d(120%, 0, 0)',
			position: "fixed",
			top: "3px",
			right: "10px",
			marginTop: "5px",
			width: "300px"
		};
		return (
			<div className="ts card" style={cardStyle}>
                <div className="extra content">
                    <div className="actions">
                        <div className="ts separated icon buttons">
                            <button className="ts circular icon button" onClick={this.closeCard.bind(this)}>
                                <i className="remove icon"></i>
                            </button>
                        </div>
                    </div>
                    <div className="header">
                        <i className="cloud icon"></i>
                        雲模組
                    </div>
                    <div className="meta">
                        <div>
                            點擊下方按鈕選擇功能
                        </div>
                    </div>
                </div>
	            <div className="content" style={{textAlign: "center"}}>
	                <div className="description">
	                    <div className="ts grid">
	                        <div className="row" id="surveyingRow">                    
	                            <div className="six wide column">
	                                離地高
	                            </div>
	                            <div className="six wide column">
	                                <div class="ts mini circular input">
	                                    <input type="number" placeholder="離地高" value={this.state.surfaceHeight} onChange={(e)=>this.surfaceHeightChange(e)}></input>
	                                </div>
	                            </div>
	                        </div>                        
	                    </div>
	                    <div className="ts grid">
	                        <div className="row" id="surveyingRow">                    
	                            <div className="six wide column">
	                                雲層高
	                            </div>
	                            <div className="six wide column">
	                                <div class="ts mini circular input">
	                                    <input type="number" placeholder="雲層高" value={this.state.height} onChange={(e)=>this.heightChange(e)}></input>
	                                </div>
	                            </div>
	                        </div>                        
	                    </div>
	                    <div className="ts grid">
	                        <div className="row">
	                            <div className="eight wide column">
	                                <button className="ts circular icon button" onClick={this.createCloud}>
	                                    <i className="plus icon"></i>
	                                    新增
	                                </button>                                             
	                            </div>
	                            <div className="eight wide column">
	                                <button className="ts circular icon button" onClick={this.clearCloud}>
	                                    <i className="trash outline icon"></i>
	                                    清除
	                                </button>                                               
	                            </div>
	                        </div>                        
	                    </div>
	                </div>
	            </div>
            </div>
		);
	}
}

export default CloudModule;